import { render, staticRenderFns } from "./AuftragTable.vue?vue&type=template&id=1fd2135a&scoped=true"
import script from "./AuftragTable.vue?vue&type=script&lang=js"
export * from "./AuftragTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd2135a",
  null
  
)

export default component.exports